// extracted by mini-css-extract-plugin
export default {"forumPosts":"vhfx5lv09JoCubCJzDn_"};